import { getAllActivityLogs } from '@dyl/apiClients/backendApi';
import { useState, useEffect } from 'react';
import { useLevels } from "@dyl/systems/LevelsManager";
import { getTasks } from '../apiClients/backendApi'


const useActivityLogs = (logType, logId, reload, isChangeMode) => {
  const [records, setActivityRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const { globalLevel } = useLevels();
  useEffect(() => {
    const retrieveActivityLogs = async () => {
      setLoading(true);
      try {
        const data = await getAllActivityLogs(logType, logId);

        // Skip getTasks call for arc_template logs
        if (logType === 'arc_template') {
          setActivityRecords(data);
          setLoading(false);
          return;
        }

        const testData = await getTasks(globalLevel.level_id);
        const productiveTasks = testData.filter(
          task => task.task_type_id === 'productive_writing'
        );
        const productiveTaskIds = productiveTasks.map(task => task.task_id);
        const hasProductiveWritingMatch = data.some(item =>
          productiveTaskIds.includes(item.task_id)
        );

        let finalData;

        if (hasProductiveWritingMatch) {
          finalData = data.filter(
            item =>
              productiveTaskIds.includes(item.task_id) &&
              item.changed_field?.includes('Example')
          );
        } else {
          finalData = data;
        }
        setActivityRecords(finalData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching activity logs:', error);
        setLoading(false);
      }
    };

    retrieveActivityLogs();
  }, [logId, logType, getAllActivityLogs, reload, isChangeMode]);

  return { records, loading };
};

export default useActivityLogs;